

import React from 'react';

export default () => {
  return (
    <>
      <main className="content-container">
        <h2>À propos</h2>
        <p>
Enquêter sur EME est l’un des éléments d’une étude de cas menée par Robin de Mourat, designer de formation, dans le cadre d’une recherche de doctorat menée à l’Université Rennes 2, sous la direction de Nicolas Thély (financement par contrat doctoral ENS Cachan).
</p>
<p>
Ce travail doctoral prend pour objet d'étude les pratiques de publication et d'édition scientifique émergentes dans le milieu académique des sciences humaines et sociales. Il vise plus précisément à questionner la manière dont les pratiques critiques - dont le “design” peut parfois prendre le nom - interviennent dans la reconfiguration des savoirs et des pratiques savantes dans un contexte socio-technique encore et toujours bouleversé par la numérisation.
</p>
<p>
Il a été réalisé en situation d’observation participante avec le concours de Donato Ricci (docteur en design de la communication, design lead du projet AIME), et avec le support de l’équipe du médialab, et en particulier d’Eleonora Grotto (design graphique) et de Daniele Guido (développement).
</p>
<p>
Il fait office de conclusion provisoire à une complexe situation “d’observation par le design” au sein du médialab Sciences Po, visant à expérimenter différents modes d’analyse et d’interprétation de dispositifs de publication en Humanités Numériques, au moyen d’instruments d’observation utilisant des technologies numériques.
</p>
<p>
Les polices de caractère utilisées sont Aleo et Anonymous, polices open source.
</p>
      </main>
      <aside>
      </aside>
    </>
  )
}